import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/notificaciones',
    name: 'notificaciones.index',
    component: () => import('./views/NotificacionesView.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      breadcrumb: 'Notificaciones',
    },
  },
  {
    path: '/portal/notificaciones',
    name: 'portal.notificaciones',
    component: () => import('./views/NotificacionesView.vue'),
    meta: {
      layout: 'portal',
      requiresAuth: true,
      breadcrumb: 'Notificaciones',
    },
  },
]

export default routes
